import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "../query/querykeys";
import ApiRequest from "../ApiRequest";
import type { ResponseType } from "../types/axiosResponseType";

type DeleteNotificationResponse = ResponseType<null>;

export function useDeleteNotificationMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (notificationId: string) => {
      const res = await ApiRequest.delete<DeleteNotificationResponse>(
        `${requestURLs.notification}${notificationId}`
      );
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allNotification] });
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.notificationHistory] });
    },
  });
}
